import { OnInit, Component, AfterViewChecked } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService } from "primeng/primeng";
import { MessageService } from "primeng/components/common/messageservice";
import { WebPage } from "../../../shared/web-page";
import { Indicacao } from "../../../../models/indicacao.model";
import { AuthService } from "../../../admin/auth.service";
import { EmpresaService } from "../../../../services/empresa.service";
import { Perfis } from "../../../../models/perfis";
import { Util } from "../../../shared/util";

@Component({
  templateUrl: './indicacao.component.html',
  styleUrls: ['./indicacao.component.css'],
})

export class IndicacaoComponent extends WebPage implements OnInit, AfterViewChecked {

  isLoading: boolean =false;
  usuario: any = {};
  perfis: any = {};
  
  form: FormGroup = {} as FormGroup;
  listaIndicacoes: Array<Indicacao> = [];
  registroModal: Indicacao = null;

  hoje = new Date().toISOString().split('T')[0];

  public inputCpf: string;
  public inputNome: string;

  constructor(
    private _router: Router,
    messageService: MessageService,
    private fb: FormBuilder,
    private authService: AuthService,
    private _empresaService: EmpresaService,
    private confirmationService: ConfirmationService,
  ){
      super(messageService);
  }
  
  ngAfterViewChecked(): void {
    //throw new Error("Method not implemented.");
  }
  ngOnInit() {
    this.isLoading = true;
    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_public-layout/pages/indicacao/indicacao.component.ts